import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { rememberFieldTypeRows, rememberReservedFieldTypeIds } from 'src/app/shared/formula/formula.types';

@Injectable({
  providedIn: 'root'
})
export class EditContactService {
  BASE_URL: string;
  ITEM_MODULE_URL: string;

  constructor(private http: HttpClient) {
    this.BASE_URL = environment.API_URL;
    this.ITEM_MODULE_URL = environment.ITEM_MODULE_URL
  }


  addContact(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/merchantcustomer', data)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  addCustomField(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/customercustomfield', data)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  updateCustomField(id, data: any = ''): Observable<any> {
    return this.http.put(this.BASE_URL + '/customercustomfield', { ...data, id })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }


  addPackage(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/customerpackage', data)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  updatePackage(id, data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/customerpackage/edit', { ...data, id })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  addClientTypes(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/clienttypes', data)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  addformOfContactTypes(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/formcontacts', data)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  updateformOfContactTypes(data: any = ''): Observable<any> {
    return this.http.put(this.BASE_URL + '/formcontacts', data)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }


  deleteformOfContactTypes(id: any = ''): Observable<any> {
    return this.http.delete(`${this.BASE_URL}/formcontacts/` + id).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

  deleteformOfClientTypes(id: any = ''): Observable<any> {
    return this.http.delete(`${this.BASE_URL}/clienttypes/` + id).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

  deleteRoleForm(id: any = ''): Observable<any> {
    return this.http.delete(`${this.BASE_URL}/merchantrole/` + id).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }


  addRole(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/merchantrole', data)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }


  editContact(data: any = ''): Observable<any> {
    return this.http.patch(this.BASE_URL + '/merchantcustomer', data)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  updateOrganizationMember(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/merchantorganization', data)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  viewContact(id): Observable<any> {
    return this.http.get(this.BASE_URL + '/merchantcustomer/' + id)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  industriesList(resource = '') {
    return this.http.post(this.BASE_URL + '/industry/list', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  socialLinks(data: any = ''): Observable<any> {
    return this.http.post(`${this.BASE_URL}/sociallinks/list`, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }


  getLanguage(data: any = ''): Observable<any> {
    return this.http.post(`${this.BASE_URL}/language/list`, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

  // getAudience(data: any = ''): Observable<any> {
  //   return this.http.post('../../assets/json/audience.json', data).pipe(
  //     tap(
  //       data => data,
  //       error => error
  //     )
  //   );
  // }

  getAudience(): Observable<any> {
    return this.http.get('../../assets/json/audience.json')
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  getPrice(data: any = ''): Observable<any> {
    return this.http.post(`${this.BASE_URL}/prices/list`, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

  phoneCode(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/phonecode/list', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }



  countryList(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/country/list', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  formContactList(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/formcontacts/list', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  clientTypesList(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/clienttypes/list', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  customFieldList(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/customfield/list', data).pipe(
      // Card #566: the type rows name Formula and Number; keep their ids.
      tap((response: unknown) => rememberFieldTypeRows((response as { data?: unknown } | null)?.data)),
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  customerCustomFieldListItems(data: any = ''): Observable<any> {
    return this.http.post(this.ITEM_MODULE_URL + '/customFieldList', data).pipe(
      // Card #566: the Formula / Number type ids ride on this response.
      tap((response: unknown) => rememberReservedFieldTypeIds(response)),
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  customerCustomFieldList(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/customercustomfield/list', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  citiesList(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/cities/list', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  roleList(data: any = ''): Observable<any> {
    return this.http.post(`${this.BASE_URL}/merchantrole/list`, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

  deleteCustomField(id: any = ''): Observable<any> {
    return this.http.delete(`${this.BASE_URL}/customercustomfield/` + id).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

  deletePackage(id: any = ''): Observable<any> {
    return this.http.delete(`${this.BASE_URL}/customerpackage/delete/` + id).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

  updateCustomeOrder(data: any = ''): Observable<any> {
    return this.http.put(this.BASE_URL + '/customercustomfield/order', { data })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  getOrganizationList(data: any = ''): Observable<any> {
    return this.http.post(`${this.BASE_URL}/merchantorganization/list`, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

}
